import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { IsProductTermType } from '../../../constants/termTypes';
import Tree from '../../common/tree/Tree';
import partition from 'lodash/partition';
import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';
import ContractCard from './ContractCard';

const DEFAULT_OPEN_THRESHOLD = 5;

class SkuTreeView extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    termsByBuyer: PropTypes.object.isRequired,
    onSelectTerm: PropTypes.func.isRequired,
    selectedTerm: PropTypes.object,
    showTerminated: PropTypes.bool
  };

  state = {
    selectedTerm: undefined
  };

  render() {
    const { t, termsByBuyer } = this.props;

    const sortedBuyerAndTerms = sortBy(termsByBuyer, buyer => buyer.name);

    const childrenNodes = map(sortedBuyerAndTerms, buyer => {
      return {
        style: { marginBottom: '5px' },
        content: <b>{buyer.name}</b>,
        key: buyer.name,
        defaultOpen: sortedBuyerAndTerms.length <= DEFAULT_OPEN_THRESHOLD,
        childrenNodes: compact(
          partition(buyer.terms, t => IsProductTermType(t.type)).map((terms, idx) => {
            return (
              !isEmpty(terms) && {
                content:
                  idx === 0 ? t('createContract:pricingContract.title') : t('createContract:shippingContract.title'),
                key: buyer.name + idx,
                defaultOpen: terms.length < DEFAULT_OPEN_THRESHOLD,
                childrenNodes: terms.map(t => ({
                  content: <ContractCard term={t} />,
                  key: t.termId,
                  selected: this.props.selectedTerm && this.props.selectedTerm.termId === t.termId,
                  onClick: () => this.props.onSelectTerm(t)
                }))
              }
            );
          })
        )
      };
    });

    return <Tree nodes={childrenNodes} />;
  }
}

export default withTranslation()(SkuTreeView);
